<template>
  <div>
    <div class="popupBlurBg" :class="{on:show}" @click.stop="onClickClose"></div>
    <section class="slidePopup dark sample" :class="{on:show}" style="display:block;">
      <div class="topArea">
        <p>{{ title }}</p>
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="titleArea">
          <h2>{{ `${dialogStore.options.props?.trackLevel.assessmentSetInfoVO.trackTitle} - ${dialogStore.options.props?.trackLevel.assessmentSetInfoVO.trackLevelTitle}` }}</h2>
          <!-- TODO: SkillAdvance 잠정 비활성화 -->
<!--          <div class="linkedTrack">-->
<!--            <span>{{ t('advance-related-practice') }}</span>-->
<!--            <a @click.stop="onClickShiftTrackDetail"><span class="icon"></span>{{ dialogStore.options.props?.trackLevel.assessmentSetInfoVO.trackTitle }}</a>-->
<!--          </div>-->
        </div>
        <div v-if="dialogStore.options.props?.isReference" class="view">
          <LazyLearningAPIReference :reference-url="dialogStore.options.props?.trackLevel?.referenceUrl" />
        </div>

        <LazyProSkillAssureSettingsCommonAssessmentSetsCardSample v-else />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {computed, ref, useRoute, useRouter} from '#imports'
import {useDialogStore} from "~/store/dialog/dialogStore";
import {useI18n} from "vue-i18n";
import {TrackType} from '~~/package/mapper/track/model/TrackType';

const {t} = useI18n()

const dialogStore = useDialogStore();
const router = useRouter();

const show = ref(false);

const title = computed(() => dialogStore.options.props.isReference ? t('skillCertify-api-reference') : t('skillCertify-actual-question') );

onMounted(() => {
  nextTick(() => {
    setTimeout(() => {
      show.value = true
    }, 10)
  })
});

const onClickShiftTrackDetail = () => {
  const trackDetailRouteData = router.resolve({
    name: "dashboard-skillAdvance-practice-practiceId",
    params: { practiceId: dialogStore.options.props.trackLevel.assessmentSetInfoVO.trackId }
  });
  window.open(trackDetailRouteData.href, "_blank");
};

const onClickClose = () => {
  show.value = false;
  dialogStore.close();
};
</script>

